import React from 'react';
import styles from './Teams.module.scss';
import { TeamMembers } from 'new/components/TeamsTable/TeamMembers';
import { Column } from 'new/elements/Table/types';
import { Team } from 'new/entities/Team';
import { Typography } from '@mui/material';

export const columns = [
  {
    name: 'Name',
    field: 'name',
    tdClassName: styles.team_name,
    renderRow: (row) => {
      return <Typography variant="caption">{row.name}</Typography>;
    },
    width: 20,
  },
  {
    name: 'Description',
    field: 'description',
    width: 35,
  },
  {
    name: 'Members',
    field: 'members',
    renderRow: TeamMembers,
  },
] as Column<Team>[];
